import { render, staticRenderFns } from "./HomeNotesRead.vue?vue&type=template&id=6842df9b&scoped=true"
import script from "./HomeNotesRead.vue?vue&type=script&lang=js"
export * from "./HomeNotesRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6842df9b",
  null
  
)

export default component.exports